import { useState, useEffect } from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";

export default function Header() {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  return (
    <header className="fixed top-0 w-full z-50 backdrop-blur-md bg-white/70 dark:bg-gray-900/70 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        
        {/* LOGO */}
        <h1 className="text-xl font-extrabold tracking-wide text-blue-600">
          Ranjit<span className="text-gray-800 dark:text-gray-200">.dev</span>
        </h1>

        {/* NAV */}
        <nav className="hidden md:flex gap-10 text-sm font-medium">
          <a href="#home" className="hover:text-blue-600">Home</a>
          <a href="#about" className="hover:text-blue-600">About</a>
          <a href="#projects" className="hover:text-blue-600">Projects</a>
          <a href="#contact" className="hover:text-blue-600">Contact</a>
        </nav>

        {/* ACTIONS */}
        <div className="flex items-center gap-4">
          <a href="https://github.com/ranjeetgtm" target="_blank">
            <FaGithub size={18} />
          </a>
          <a href="https://linkedin.com/in/ranjeetgtm" target="_blank">
            <FaLinkedin size={18} />
          </a>
          <button
            onClick={() => setDark(!dark)}
            className="text-xs px-3 py-1 rounded-full border hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            {dark ? "Light" : "Dark"}
          </button>
        </div>
      </div>
    </header>
  );
}
